import axios from 'axios'
import { CommonLaboratoryResponse } from '@/api/services/common.dto'

class CommonLaboratoryService {
    async getAllActiveLaboratories(): Promise<CommonLaboratoryResponse[]> {
        const response = await axios.get<CommonLaboratoryResponse[]>(`/common/laboratories/`)
        return response.data
    }
    async getCaseLaboratories(caseId: number): Promise<CommonLaboratoryResponse[]> {
        const response = await axios.get<CommonLaboratoryResponse[]>(`/common/laboratories/case/${caseId}`)
        return response.data
    }
}

export const commonLaboratoryService = new CommonLaboratoryService()
